import API from './API'

export default {
  // load single proje
  getPromo: function(promo_id) {
    return API.get(`/api/coupons/${promo_id}`);
  },
};
